import { render, staticRenderFns } from "./ApplicantNavbarVertical.vue?vue&type=template&id=662d30dc&"
import script from "./ApplicantNavbarVertical.vue?vue&type=script&lang=js&"
export * from "./ApplicantNavbarVertical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports